import { sendMessage } from '../lib/utils'
import { useState, useEffect } from 'preact/hooks'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../lib/api/api-client'

export function useMessagesListener() {
  const [sparkfireToken, setSparkfireToken] = useState(null)
  const [listening, setListening] = useState(false)
  const queryClient = useQueryClient()

  const { mutateAsync: identifyContact } = useMutation({
    mutationFn: (contact : {
      first_name: string,
      last_name: string,
      email: string
    }) => {
      return apiClient.post(`/contacts/me`, contact)
    },
    onSuccess: () => {
      sendMessage('identified')
    },
    onError: (error) => {
      sendMessage('identifyFailed', { error })
    }
  })

  const { mutateAsync: sendChatMessage } = useMutation({
    mutationFn: (text: string) => {
      return apiClient.post(`/messages`, {
        text,
      })
    },
    onSuccess: () => {
      sendMessage('messageSent')
      queryClient.invalidateQueries({ queryKey: ['messages'] })
    },
    onError: (error) => {
      sendMessage('messageSendFailed', { error })
    }
  })

  useEffect(() => {
    function handleReceiveMessage(event) {
      if (event.data.event_type == "set_app_token" && event.data.sparkfire_token) {
        setSparkfireToken(event.data.sparkfire_token)
      } else if (event.data.event_type == "identify") {
        identifyContact(event.data)
      } else if (event.data.event_type == "send_chat_message") {
        sendChatMessage(event.data.message)
      }
    }

    window.addEventListener('message', handleReceiveMessage)
    setListening(true)

    return () => {
      window.removeEventListener('message', handleReceiveMessage)
      setListening(false)
    }
  }, [identifyContact, sendChatMessage])

  useEffect(() => {
    if (sparkfireToken) {
      localStorage.setItem('sparkfire_token', sparkfireToken)
    }
  }, [sparkfireToken])

  return { sparkfireToken, listening }
}